module.exports = __webpack_public_path__ + "img/graduation-icon.27b03d7a.svg";